import { render, staticRenderFns } from "./detailed-dialog.vue?vue&type=template&id=0de862ce&scoped=true"
import script from "./detailed-dialog.vue?vue&type=script&lang=js"
export * from "./detailed-dialog.vue?vue&type=script&lang=js"
import style0 from "./detailed-dialog.vue?vue&type=style&index=0&id=0de862ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de862ce",
  null
  
)

export default component.exports